import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import WorldMap from "./ui/world-map"; // make sure this is a valid component

const WorldPresence = () => {
  const [dots, setDots] = useState(null);

  useEffect(() => {
    // Simulate loading data
    const timer = setTimeout(() => {
      setDots([
        {
          start: { lat: 64.2008, lng: -149.4937 },
          end: { lat: 34.0522, lng: -118.2437 },
        },
        {
          start: { lat: 64.2008, lng: -149.4937 },
          end: { lat: -15.7975, lng: -47.8919 },
        },
        {
          start: { lat: -15.7975, lng: -47.8919 },
          end: { lat: 38.7223, lng: -9.1393 },
        },
        {
          start: { lat: 51.5074, lng: -0.1278 },
          end: { lat: 28.6139, lng: 77.209 },
        },
        {
          start: { lat: 28.6139, lng: 77.209 },
          end: { lat: 43.1332, lng: 131.9113 },
        },
        {
          start: { lat: 28.6139, lng: 77.209 },
          end: { lat: -1.2921, lng: 36.8219 },
        },
      ]);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="mt-10 p-5 bg-white dark:bg-black w-full">
      <div className="max-w-7xl mx-auto text-center">
        <p className="font-bold text-xl md:text-4xl text-black dark:text-white">
          Where we{" "}
          <span className="text-neutral-400">
            {"work".split("").map((letter, idx) => (
              <motion.span
                key={idx}
                className="inline-block"
                initial={{ x: -10, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: idx * 0.04 }}
              >
                {letter}
              </motion.span>
            ))}
          </span>
        </p>
        <p className="text-sm md:text-lg text-neutral-500 max-w-2xl mx-auto py-4">
          The environment where we work greatly influences productivity and creativity. Whether at home, in an office, or a co-working space, the setting shapes our success.
        </p>
      </div>

      {dots ? (
        <WorldMap dots={dots} />
      ) : (
        <div className="flex justify-center items-center h-96">
          <motion.div
            className="w-12 h-12 border-4 border-gray-400 border-t-transparent rounded-full animate-spin"
            initial={{ rotate: 0 }}
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
          />
        </div>
      )}
    </div>
  );
};

export default WorldPresence;
